export default __webpack_public_path__ + "static/media/ibelsa-logo.31f6f1ee.png";